import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {RouterModule} from "@angular/router";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AluguelComponent } from "./aluguel.component";
import { CadastroAluguelComponent } from "./cadastro.component";

@NgModule({
  declarations: [
    AluguelComponent,
    CadastroAluguelComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    AluguelComponent
  ]
})

export class AluguelModule {}
